export default __webpack_public_path__ + "static/media/favorites-earbuddyzpro-comp.732b44a7.png";